import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { Button } from "../components/ui/button"
import {
  Calendar,
  Phone,
  MapPin,
  Clock,
  Star,
  Award,
  Heart,
  Shield,
  Building2,
  Package,
  Stethoscope,
  PlusCircle,
  Baby,
  Bone,
  Brain,
  Microscope,
  ChevronRight,
  Download,
  CheckCircle,
  Trophy,
  BadgeIcon as Certificate,
  User,
  ArrowRight,
} from "lucide-react"

import { Badge } from "../components/ui/badge"
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "../components/ui/carousel"

import { DoctorCard } from "../components/doctor-card"
import { TestimonialCard } from "../components/testimonial-card"
import { BlogCard } from "../components/blog-card"
import { ServiceCard } from "../components/service-card"
import { PackageCard } from "../components/package-card"
import { NewsletterForm } from "../components/newsletter-form"
import { QuickAccessCard } from "../components/quick-access-card"
import { AwardCard } from "../components/award-card"
import Herosectionwidget from "../components/widgets/herosection"
import QuickAccessTileswidget from "../components/widgets/quickaccesstiles"
import Aboutuswidget from "../components/widgets/aboutus"
import OurSpecialtieswidget from "../components/widgets/ourspecialties"
import  Diagnosticswidget  from "../components/widgets/diagnostics"
import Healthcheckupspackageswidget from "../components/widgets/healthcheckupspackages"
import OurDoctorswidget from "../components/widgets/ourdoctors"
import Testimonialswidget from "../components/widgets/testimonials"
import HealthArticleswidget from "../components/widgets/healtharticles"
import Awardswidget from "../components/widgets/awards"
import Locationswidget from "../components/widgets/locations"
import MobileAppPromowidget from "../components/widgets/mobileapppromo"
import NewsLetterwidget from "../components/widgets/newsletter"
import { FixedAppointmentButtons } from "../components/FixedAppointmentButtons"
import SEO from "./SEO"


export default function Home() {
 const homeSchema = [
  {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    "name": "Pranaam Hospitals",
    "url": "https://pranaamhospitals.com/",
    "logo": "https://pranaamhospitals.com/images/pranaam-logo.png",
    "description": "Pranaam Hospitals is a NABH-accredited multi-specialty hospital in Hyderabad delivering compassionate, patient-centric healthcare from newborns to seniors.",
    "foundingDate": "2015",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "addressCountry": "IN"
    },
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "telephone": "+91-99660-60000",
        "email": "info@pranaamhospitals.in",
        "availableLanguage": ["English", "Telugu", "Hindi"]
      }
    ],
    "sameAs": [
      "https://www.facebook.com/pranaamhospitals",
      "https://www.instagram.com/pranaamhospitals",
      "https://www.linkedin.com/company/pranaamhospitals"
    ]
  },

  {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://pranaamhospitals.com/"
    },
    "headline": "Pranaam Hospitals – Complete Healthcare Under One Roof",
    "description": "Pranaam Hospitals provides comprehensive multi-specialty healthcare services in Hyderabad with expert doctors, advanced diagnostics, and 24/7 emergency care.",
    "image": "https://pranaamhospitals.com/wp-content/uploads/2025/hospital-building.jpg",
    "author": {
      "@type": "Organization",
      "name": "Pranaam Hospitals"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Pranaam Hospitals",
      "logo": {
        "@type": "ImageObject",
        "url": "https://pranaamhospitals.com/wp-content/uploads/2025/logo.png"
      }
    },
    "datePublished": "2015-01-01",
    "dateModified": "2025-04-01",
    "keywords": [
      "Pranaam Hospitals Hyderabad",
      "best multi specialty hospital in Hyderabad",
      "NABH hospital Hyderabad",
      "24/7 emergency hospital Hyderabad"
    ],
    "articleSection": [
      "Medical Specialties",
      "Diagnostics",
      "Health Packages",
      "Emergency Services",
      "Patient Care"
    ],
    "about": {
      "@type": "MedicalOrganization",
      "name": "Pranaam Hospitals",
      "url": "https://pranaamhospitals.com/"
    }
  }
];




  const [visibleWidgets, setVisibleWidgets] = useState([]);
  const [seo, setSeo] = useState({});
  const [pageKeywords, setPageKeywords] = useState("");
    useEffect(() => {
fetch("/wp-json/custom/v1/homepage-widgets")
  .then(res => res.json())
  .then(data => {
    const widgetsArray = Object.values(data);
    setVisibleWidgets(widgetsArray);
  })
  .catch(err => {
    console.error("Failed to load widgets", err);
    setVisibleWidgets([]);
  });

fetch("/wp-json/custom/v1/page-seo?slug=home")
  .then(res => res.json())
  .then(data => { if (data?.seo) setSeo(data.seo); setPageKeywords(data?.keywords || ""); })
  .catch(() => {});
}, []);

  const renderWidget = (id) => {
    switch (id) {
      case "hero-section":
        return <Herosectionwidget />;
      case "quick-access-tiles":
        return <QuickAccessTileswidget />;
      case "about-us":
        return <Aboutuswidget />;
        case "our-specialties":
        return <OurSpecialtieswidget />;
        case "diagnostics":
        return <Diagnosticswidget />;
        case "health-checkup-packages":
        return <Healthcheckupspackageswidget />;
        case "our-doctors":
        return <OurDoctorswidget />;
        case "testimonials":
        return <Testimonialswidget />;
        case "health-articles":
        return <HealthArticleswidget />;
        case "awards":
        return <Awardswidget />;
        case "locations":
        return <Locationswidget />;
        case "mobile-app-promo":
        return <MobileAppPromowidget />;
        case "news-letter":
        return <NewsLetterwidget />;

        
      default:
        return null;
    }
  };

  return (
     <>
     <SEO
        title={seo.title || "Pranaam Hospitals | Best Multi-Specialty Hospital in Hyderabad"}
        description={seo.description || "NABH-accredited multi-specialty hospital in Hyderabad offering expert doctors, diagnostics & 24/7 emergency care."}
        canonical={seo.canonical || "https://pranaamhospitals.com/"}
        robots={Array.isArray(seo.robots) ? seo.robots.join(", ") : seo.robots || "index, follow"}
        keywords={pageKeywords}
        ogTitle={seo.og_title}
        ogDescription={seo.og_description}
        ogImage={seo.og_image || seo.featured_image}
        twitterTitle={seo.twitter_title}
        twitterDescription={seo.twitter_description}
        author="Pranaam Hospitals"
        publisher="Pranaam Hospitals"
        schema={homeSchema}
     />

 

    <div className="flex flex-col min-h-screen">
      <main className="pb-20 md:pb-0">
         
        {/* <QuickAccessTileswidget />
        <Aboutuswidget />
        <OurSpecialtieswidget />
        <Diagnosticswidget />
        <Healthcheckupspackageswidget />
        <OurDoctorswidget />
        <Testimonialswidget />
        <HealthArticleswidget />
        <Awardswidget />
        <Locationswidget />
        <MobileAppPromowidget />
        <NewsLetterwidget />   */}
        <div>
          {visibleWidgets.map(widget => (
            <div key={widget.widget_id}>
              {renderWidget(widget.widget_id)}
            </div>
          ))}
        </div>  
      </main>
    </div>
    </>
  )
}
